// extracted by mini-css-extract-plugin
export default {"Flipper":"flipper_Flipper__tIK+0","Border":"flipper_Border__y3BZD","Front":"flipper_Front__aqytS","Back":"flipper_Back__bZMD+"};